import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { PremiumPayContainerComponent } from './premium-pay-container/premium-pay-container.component';
const log = new LoggingService();

export const PremiumPayRoute: Ng2StateDeclaration = {
    // name: 'PayrollItem.**'
    name: 'premiumpay',
    url: '/premiumpay',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.PayrollItemModule)
    data: { requiresAuth: true },

    component: PremiumPayContainerComponent
};
